__turbopack_context__.v({
  "avatarBlock": "profile-image-input-module__HBuaPq__avatarBlock",
  "avatarImage": "profile-image-input-module__HBuaPq__avatarImage",
  "avatarPlaceholder": "profile-image-input-module__HBuaPq__avatarPlaceholder",
  "avatarRoot": "profile-image-input-module__HBuaPq__avatarRoot",
  "avatarTrigger": "profile-image-input-module__HBuaPq__avatarTrigger",
  "cropBlock": "profile-image-input-module__HBuaPq__cropBlock",
  "cropControls": "profile-image-input-module__HBuaPq__cropControls",
  "cropFrame": "profile-image-input-module__HBuaPq__cropFrame",
  "cropTitle": "profile-image-input-module__HBuaPq__cropTitle",
  "hint": "profile-image-input-module__HBuaPq__hint",
  "removeButton": "profile-image-input-module__HBuaPq__removeButton",
  "root": "profile-image-input-module__HBuaPq__root",
});
